import { ThemeProvider } from "@mui/material/styles";
import { ResultLayout } from "./components/ResultLayout";
import { platformTheme } from "../../styles/platformTheme";
import "./HomeView.css";

export const HomeView = () => {
  return (
    <ThemeProvider theme={platformTheme}>
      <ResultLayout />
    </ThemeProvider>
  );
};
